import { useEffect, useState } from 'react'
import { Outlet } from 'react-router'
import InitialPropsContext from './InitialPropsContext/InitialPropsContext'
import {
  BootstrapLoading,
  BootstrapRedirecting,
  BootstrapUnavailable
} from './BootstrapScreen'
import { BootstrapResult, resolveTenant } from '../bootstrap/tenant'
import { redirect } from '../utils/redirect'

// What `_app.tsx` did, minus the server. Next resolved the tenant during SSR and
// passed the result down as pageProps; the same resolution now runs in the browser
// and no route renders until it settles.
const RootLayout = () => {
  const [result, setResult] = useState<BootstrapResult>()

  useEffect(() => {
    resolveTenant().then(setResult)
  }, [])

  // window.location.replace is asynchronous, so the screen has to say something
  // while the browser gets around to it.
  useEffect(() => {
    if (result?.status === 'redirect') {
      redirect({ target: result.target })
    }
  }, [result])

  if (!result) {
    return <BootstrapLoading />
  }

  if (result.status === 'unavailable') {
    return <BootstrapUnavailable />
  }

  if (result.status === 'redirect') {
    return <BootstrapRedirecting />
  }

  return (
    <InitialPropsContext.Provider value={result.tenant}>
      <Outlet />
    </InitialPropsContext.Provider>
  )
}

export default RootLayout
